<template>
    <div v-if="!isMobile">
        <!-- INICIO NEW EVENT FORM -->
        <BaseModal modalId="newEventForm" :title="'Agregar Evento'" :isVisible="true" @close="cancelar">

            <div>
                <div class="modal-body">

                    <div class="row d-flex align-items-center mb-1">
                        <div class="col-3">
                            <label>Creación</label>
                        </div>

                        <div class="col-4">
                            <input class="form-control form-control-sm" type="date" id="creacion_fecha" v-model="fecha">
                        </div>

                        <div class="col-3">
                            <input class="form-control form-control-sm" type="time" id="creacion_hora" v-model="hora">
                        </div>

                        <div class="col-2">
                            <button class="btn btn-secondary btn-sm" id="ahora" @click="setAhora">Ahora</button>
                        </div>
                    </div>

                    <div class="row d-flex align-items-center mb-1">
                        <div class="col-3">
                            <label>Tipo</label>
                        </div>

                        <div class="col-4">
                            <select class="form-select form-select-sm" aria-label="Default select example"
                                v-model="eventTypeSelected">
                                <option v-for="tipo in eventTypes" :key="tipo.event_type_id"
                                    :value="{ id: tipo.event_type_id, text: tipo.event_type }">{{
                                        tipo.event_type
                                    }}</option>
                            </select>
                        </div>

                        <div class="col-2">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    v-model="visible">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Visible
                                </label>
                            </div>
                        </div>

                        <div class="col-3">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    v-model="dynamic">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Dinámico
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row d-flex align-items-center mb-1">

                        <div class="col-3">
                            <label>Alcance</label>
                        </div>

                        <div class="col-4">
                            <select class="form-select form-select-sm" aria-label="Default select example"
                                v-model="selectedScope">
                                <option v-for="alc in alcances" :key="alc">{{ alc }}</option>
                            </select>
                        </div>

                        <div class="col-2">
                            <label>Estado</label>
                        </div>
                        <div class="col-3">
                            <select class="form-select form-select-sm" aria-label="Default select example"
                                v-model="selectedState">
                                <option v-for="est in estados" :key="est">{{ est }}</option>
                            </select>
                        </div>


                    </div>

                    <div class="row d-flex align-items-center mb-1">
                        <div class="col-4">
                            <label>Ubicación</label>
                        </div>

                        <div class="col-1">
                            <label>Lat</label>
                        </div>

                        <div class="col-2">
                            <input class="form-control form-control-sm" type="text" id="lat" v-model="lat">
                        </div>

                        <div class="col-1">
                            <label>Lon</label>
                        </div>

                        <div class="col-2">
                            <input class="form-control form-control-sm" type="text" id="lon" v-model="lon">
                        </div>

                        <div class="col-1">
                            <button class="btn btn-secondary btn-sm" id="pasteCoords" @click="pasteCoords"><i
                                    class="bi bi-pin-map-fill"></i></button>
                        </div>
                    </div>


                    <div class="row d-flex align-items-center mb-1">
                        <div class="col-3">
                            <label>Descripción</label>
                        </div>

                        <div class="col-9">
                            <textarea class="form-control" id="exampleFormControlTextarea1" style="height: 100px"
                                v-model="descript"></textarea>
                        </div>
                    </div>

                    <div class="w-100 mt-3">
                        <file-uploader ref="fileUploaderRef" :show-upload-button="false" :destPath="destPath" />
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 justify-content-end d-flex">
                            <button class="btn btn-danger" id="cancelar" @click="cancelar"
                                :disabled="isSaving">Cancelar</button>
                            <button class="btn btn-success" id="aceptar" @click="saveEvent" :disabled="isSaving">
                                <span v-if="isSaving">
                                    <i class="bi bi-arrow-repeat spin"></i> Guardando...
                                </span>
                                <span v-else>
                                    Aceptar
                                </span>
                            </button>
                        </div>
                    </div>

                </div>

            </div>

            <!-- FIN NEW EVENT FORM -->
        </BaseModal>
    </div>
    <div v-if="isMobile">
        <!-- Snackbar de subida en segundo plano -->
        <div v-if="mostrandoSubida" class="upload-snackbar">
            <i class="bi bi-cloud-upload-fill"></i> Subiendo archivos multimedia...
        </div>
        <!-- Ventana mobile -->
        <div :class="['mobile-modal-overlay', { 'd-none': minimizado }]" >
            <div class="mobile-modal-content">
                <div class="row d-flex align-items-center mb-1">
                    <div class="col-12 mb-1">
                        <label>Descripción</label>
                    </div>

                    <div class="col-12">
                        <textarea class="form-control" id="exampleFormControlTextarea1" style="height: 100px"
                            v-model="descript"></textarea>
                    </div>
                </div>

                <div class="w-100 mt-3">
                    <media-capture-uploader ref="mediaUploaderRef" :show-upload-button="false" :destPath="destPath" />
                </div>
                <div class="row mt-3">
                    <div class="col-12 justify-content-end d-flex">
                        <button class="btn btn-danger" id="cancelar" @click="cancelar"
                            :disabled="isSaving">Cancelar</button>
                        <button class="btn btn-success" id="aceptar" @click="saveEvent" :disabled="isSaving">
                            <span v-if="isSaving">
                                <i class="bi bi-arrow-repeat spin"></i> Guardando...
                            </span>
                            <span v-else>
                                Aceptar
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>


<script setup lang="ts">
import { ref, onMounted } from 'vue'
// Barra flotante para subida en segundo plano
const mostrandoSubida = ref(false);
import { useServicesStore } from '@/stores/services';
import { storeToRefs } from 'pinia';
import type { APIResponse, EventType, NewEventData, NewEventInput, NewEventResponse } from '@/types';
import { estados, alcances } from '@/staticData';
import API from "../services";
import { AxiosError } from "axios";
import BaseModal from './base/BaseModal.vue'
import { useAuthStore } from '../stores/t-auth'
import FileUploader from './FileUploader.vue';
import { useUtils } from '@/composables/useUtils';
import { useGlobalStore } from '@/stores/global';
import MediaCaptureUploader from './MediaCaptureUploader.vue';


// Crear la referencia del template
const fileUploaderRef = ref<InstanceType<typeof FileUploader> | null>(null);
// Crear la referencia del template para MediaCaptureUploader
const mediaUploaderRef = ref<InstanceType<typeof MediaCaptureUploader> | null>(null);

// Definiciones de variables y referencias
const auth = useAuthStore()
const { getMimeTypeFromExtension } = useUtils();

const datos = useServicesStore();
const { eventTypes } = storeToRefs(datos);

const globalStore = useGlobalStore();
const { coordinatesClipboard, isMobile } = storeToRefs(globalStore);

const state = ref(estados)
const scope = ref(alcances)
const destPath = ref('/events/AW')
const props = defineProps<{
    newEventData: NewEventData
}>()

const fecha = ref('')
const hora = ref('')
const lat = ref(0)
const lon = ref(0)
const eventTypeSelected = ref({ id: 0, text: "" })
const selectedScope = ref("LOCAL")
const selectedState = ref("ACTIVO")
const visible = ref(false)
const dynamic = ref(false)
const descript = ref("")
const isSaving = ref(false);
const minimizado = ref(false);

onMounted(async () => {
    lat.value = props.newEventData.lat
    lon.value = props.newEventData.lon
    let tipoEvento = eventTypes.value.find(tipo => tipo.event_type_id === props.newEventData.event_type_id)
    if (tipoEvento) {
        eventTypeSelected.value = { id: tipoEvento.event_type_id, text: tipoEvento.event_type }
    }
    if ("Notification" in window && Notification.permission === "default") {
        Notification.requestPermission();
    }
})


let ahora = new Date()
//console.log(ahora.toLocaleDateString())
fecha.value = ahora.toISOString().split('T')[0]
hora.value = ahora.toISOString().split('T')[1].split('.')[0]

const emit = defineEmits<{
    (event: 'close'): void,
    (event: 'center-map', coords: [number, number]): void,
}>()

async function saveEvent() {
    isSaving.value = true;
    console.log('Guardando evento...')
    let unitId = "AW";
    let mission = 0;
    if (globalStore.patrulla.unitId && globalStore.patrulla.unitId !== "") {
        unitId = globalStore.patrulla.unitId.substring(0, 2);
        mission = globalStore.patrulla.activeMission;
    }
    let input = {
        record_unit: unitId,
        utc: fecha.value + ' ' + hora.value,
        event_number: 1,
        event_unit: unitId,
        type: eventTypeSelected.value.text,
        description: descript.value,
        mission: mission,
        reference: 0,
        location_lat: lat.value,
        location_lon: lon.value,
        state: selectedState.value,
        scope: selectedScope.value,
        visible: (visible.value) ? 1 : 0,
        data: descript.value,
        json: "",
        user_id: auth.logedUser,
    }

    try {
        const { status, data } = await API.postEvent(input);

        if (status === 200) {
            const nuevoEvento = {
                event_id: data.Entries.Entry[0].event_id,
                record_number: data.Entries.Entry[0].record_number,
                record_unit: input.record_unit,
                utc: input.utc,
                event_number: data.Entries.Entry[0].record_number,
                event_unit: input.event_unit,
                type: input.type,
                description: input.description,
                mission: input.mission,
                reference: input.reference,
                location: {
                    type: "Point",
                    coordinates: [input.location_lon, input.location_lat] as [number, number]
                },
                state: input.state,
                scope: input.scope,
                user_visible: 1,
                data: input.data,
                json: input.json,
                user_id: input.user_id,
            };

            // Agregar el evento al inicio del array global
            datos.eventsPropios.unshift(nuevoEvento);

            // Obtener el año y el mes actuales
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = String(now.getMonth() + 1).padStart(2, '0'); // Mes en formato "MM"

            destPath.value = '/events/' + currentYear + '/' + currentMonth + '/' + unitId + nuevoEvento.record_number;
            // --- SOLO MOBILE ---
            if (globalStore.isMobile && mediaUploaderRef.value && mediaUploaderRef.value.files.length > 0) {
                minimizado.value = true;
                mostrandoSubida.value = true;
                try {
                    const uploadResults = await mediaUploaderRef.value.uploadAllFiles();
                    for (const fileItem of mediaUploaderRef.value.files) {
                        if (fileItem.status === 'success') {
                            const file = fileItem.file;
                            const attachmentInput = {
                                event_id: nuevoEvento.event_id,
                                utc: nuevoEvento.utc,
                                file_name: file.name,
                                file_path: destPath.value + '/' + file.name,
                                mime_type: getMimeTypeFromExtension(file.name.split('.').pop() || ''),
                                file_ext: file.name.split('.').pop() || '',
                                user_id: auth.logedUser,
                            };
                            try {
                                await API.createEventAttachment(attachmentInput);
                                console.log(`Archivo ${file.name} asociado al evento correctamente.`);
                            } catch (error) {
                                console.error(`Error al asociar el archivo ${file.name}:`, error);
                            }
                        }
                    }
                    // Notificación al usuario
                    if ("Notification" in window && Notification.permission === "granted") {
                        new Notification("Subida completada", {
                            body: "Tus archivos multimedia han sido subidos exitosamente.",
                            icon: "/images/event_type_1.png"
                        });
                    }
                } catch (error) {
                    console.error('Error al subir archivo multimedia:', error);
                } finally {
                    mostrandoSubida.value = false;
                    emit('center-map', [nuevoEvento.location.coordinates[0], nuevoEvento.location.coordinates[1]]);
                    emit('close'); // <-- SOLO aquí cierras el modal en mobile
                }
                isSaving.value = false;
                return; // Sale para no ejecutar el cierre dos veces
            }

            // --- ESCRITORIO ---
            if (!globalStore.isMobile && fileUploaderRef.value && fileUploaderRef.value.files.length > 0) {
                try {
                    await fileUploaderRef.value.uploadAllFiles();
                    for (const file of fileUploaderRef.value.files) {
                        const attachmentInput = {
                            event_id: nuevoEvento.event_id,
                            utc: nuevoEvento.utc,
                            file_name: file.file.name,
                            file_path: destPath.value + '/' + file.file.name,
                            mime_type: getMimeTypeFromExtension(file.file.name.split('.').pop() || ''),
                            file_ext: file.file.name.split('.').pop() || '',
                            user_id: auth.logedUser,
                        };

                        try {
                            await API.createEventAttachment(attachmentInput);
                            console.log(`Archivo ${file.file.name} asociado al evento correctamente.`);
                        } catch (error) {
                            console.error(`Error al asociar el archivo ${file.file.name}:`, error);
                        }
                    }
                } catch (error) {
                    console.error('Error al subir archivos:', error);
                }
            }

            emit('center-map', [nuevoEvento.location.coordinates[0], nuevoEvento.location.coordinates[1]]);
            emit('close'); // <-- Solo escritorio llega aquí
            console.log('Evento y archivos guardados OK: ')
        }
    } catch (error) {
        const _error = error as AxiosError<string>;
        emit('close')
        console.log('Error: ' + _error)
    } finally {
        isSaving.value = false;
    }
}
function cancelar() {
    emit('close')
}
function setAhora() {
    const ahora = new Date();
    fecha.value = ahora.toISOString().split('T')[0];
    hora.value = ahora.toISOString().split('T')[1].split('.')[0];
}
function pasteCoords() {
    if (coordinatesClipboard.value) {
        lat.value = coordinatesClipboard.value.lat;
        lon.value = coordinatesClipboard.value.lon;
    }
}
</script>
<style lang="css" scoped>
.modalr {
    position: fixed;
    top: 350px;
    left: 350px;
    z-index: 15;

}

.modal-body {
    padding-left: 10px;
}

.modal-container {
    min-width: 440px;
}

@media (max-width: 576px) {
    label {
        font-size: 1em;
        margin-bottom: 5px;
    }
    .modal-container {
        min-width: calc(100% - 20px);
        width: calc(100% - 20px);
    }
    .col-12 .form-select-sm {
        width: 100%;
    }
    .form-check .form-check-input {
        height: 1.5em;
        width: 1.5em;
    }
    .form-check-label{
        font-size: 1em;
        margin-left: 1em;
    }

}

.spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}

.mobile-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.35);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mobile-modal-content {
    background: #fff;
    border-radius: 12px;
    padding: 24px 16px;
    width: 95vw;
    max-width: 420px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}

/* Snackbar para subida en segundo plano */
.upload-snackbar {
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    background: #1976d2;
    color: #fff;
    padding: 12px 24px;
    border-radius: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 10000;
}
.d-none {
    display: none !important;
}
</style>